import { createAsyncSelectors } from '@lib/selectors';
import { GetLatestImportCountsResponse, importsActions } from '@sonar-software/sonar-imports';
import { useAction, useOnMount, useSonarSelector } from '@hooks';

const selectors = createAsyncSelectors((state) => state.imports.latest.counts);

export function useLatestImportCounts(refresh = false): GetLatestImportCountsResponse {
	const getImportCounts = useAction(importsActions.requestGetImportsLatestCounts);
	const importCounts = useSonarSelector(selectors.data);

	useOnMount(() => {
		if (refresh) {
			getImportCounts();
		}
	});

	return importCounts ?? ({} as GetLatestImportCountsResponse);
}

useLatestImportCounts.selectors = selectors;
